export default __webpack_public_path__ + "static/media/iris.89400ff6.jpg";